/**
 * @generated SignedSource<<ddc1295c3726556387f52e091d8aa415>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type header_servicedeskSettingsVirtualAgentLanding$data = {
  readonly isVirtualAgentAvailable: boolean | null | undefined;
  readonly " $fragmentType": "header_servicedeskSettingsVirtualAgentLanding";
};
export type header_servicedeskSettingsVirtualAgentLanding$key = {
  readonly " $data"?: header_servicedeskSettingsVirtualAgentLanding$data;
  readonly " $fragmentSpreads": FragmentRefs<"header_servicedeskSettingsVirtualAgentLanding">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "header_servicedeskSettingsVirtualAgentLanding",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isVirtualAgentAvailable"
    }
  ],
  "type": "VirtualAgentFeatures"
};

(node as any).hash = "9ec032764c388960ac8bf1c0496cbac0";

export default node;
